// @generated by protoc-gen-es v2.2.3 with parameter "target=ts"
// @generated from file catpocs/v1/applications.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file catpocs/v1/applications.proto.
 */
export const file_catpocs_v1_applications: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_struct, file_google_protobuf_timestamp]);

/**
 * SyncPolicy defines the ArgoCD sync policy
 *
 * @generated from message catpocs.v1.SyncPolicy
 */
export type SyncPolicy = Message<"catpocs.v1.SyncPolicy"> & {
  /**
   * @generated from field: bool auto_sync = 1;
   */
  autoSync: boolean;

  /**
   * @generated from field: bool self_heal = 2;
   */
  selfHeal: boolean;

  /**
   * @generated from field: bool prune_resources = 3;
   */
  pruneResources: boolean;
};

/**
 * Describes the message catpocs.v1.SyncPolicy.
 * Use `create(SyncPolicySchema)` to create a new message.
 */
export const SyncPolicySchema: GenMessage<SyncPolicy> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 0);

/**
 * Application represents a managed ArgoCD application
 *
 * @generated from message catpocs.v1.Application
 */
export type Application = Message<"catpocs.v1.Application"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string project_id = 2;
   */
  projectId: string;

  /**
   * Kubernetes-compatible slug
   *
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * User-friendly display name
   *
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * @generated from field: string argo_name = 5;
   */
  argoName: string;

  /**
   * @generated from field: string repo_url = 6;
   */
  repoUrl: string;

  /**
   * @generated from field: string path = 7;
   */
  path: string;

  /**
   * @generated from field: string target_revision = 8;
   */
  targetRevision: string;

  /**
   * @generated from field: google.protobuf.Struct values_overrides = 9;
   */
  valuesOverrides?: JsonObject;

  /**
   * @generated from field: catpocs.v1.SyncPolicy sync_policy = 10;
   */
  syncPolicy?: SyncPolicy;

  /**
   * Unified state machine
   *
   * @generated from field: string state = 11;
   */
  state: string;

  /**
   * Error or status detail
   *
   * @generated from field: string state_message = 12;
   */
  stateMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp state_updated_at = 13;
   */
  stateUpdatedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_sync_time = 14;
   */
  lastSyncTime?: Timestamp;

  /**
   * @generated from field: string last_sync_revision = 15;
   */
  lastSyncRevision: string;

  /**
   * Soft delete timestamp (nil = active)
   *
   * @generated from field: google.protobuf.Timestamp deleted_at = 16;
   */
  deletedAt?: Timestamp;

  /**
   * "app-name" in ECR
   *
   * @generated from field: string ecr_repository = 18;
   */
  ecrRepository: string;

  /**
   * Helm path: "image.tag"
   *
   * @generated from field: string image_tag_path = 19;
   */
  imageTagPath: string;

  /**
   * Helm path: "image.repository"
   *
   * @generated from field: string image_repository_path = 20;
   */
  imageRepositoryPath: string;

  /**
   * @generated from field: string current_image_tag = 21;
   */
  currentImageTag: string;

  /**
   * @generated from field: string current_image_digest = 22;
   */
  currentImageDigest: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_deployed_at = 23;
   */
  lastDeployedAt?: Timestamp;

  /**
   * Ingress configuration (populated from ArgoCD IngressRoute resources)
   *
   * Public URL (e.g., "https://myapp.example.com")
   *
   * @generated from field: string ingress_url = 24;
   */
  ingressUrl: string;

  /**
   * True if IngressRoute status is Ready
   *
   * @generated from field: bool ingress_ready = 25;
   */
  ingressReady: boolean;

  /**
   * Latest image deployment status (ECR sync feedback)
   *
   * pending, copying, syncing, success, failed
   *
   * @generated from field: string image_deployment_status = 26;
   */
  imageDeploymentStatus: string;

  /**
   * Failure details when status is failed
   *
   * @generated from field: string image_deployment_message = 27;
   */
  imageDeploymentMessage: string;

  /**
   * Time of last deployment attempt
   *
   * @generated from field: google.protobuf.Timestamp image_deployment_at = 28;
   */
  imageDeploymentAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 29;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 30;
   */
  updatedAt?: Timestamp;

  /**
   * ECR registry URL (e.g., "123456.dkr.ecr.us-east-2.amazonaws.com")
   *
   * @generated from field: string ecr_registry = 32;
   */
  ecrRegistry: string;

  /**
   * ECR repository name (e.g., "cisco-dcloud/catpocs/proj-app")
   *
   * @generated from field: string ecr_repository_name = 33;
   */
  ecrRepositoryName: string;

  /**
   * Tag tracking configuration and observed digest state
   *
   * @generated from field: bool tag_tracking_enabled = 34;
   */
  tagTrackingEnabled: boolean;

  /**
   * @generated from field: string tracked_image_tag = 35;
   */
  trackedImageTag: string;

  /**
   * @generated from field: string tracked_image_digest = 36;
   */
  trackedImageDigest: string;

  /**
   * @generated from field: google.protobuf.Timestamp tracked_image_updated_at = 37;
   */
  trackedImageUpdatedAt?: Timestamp;

  /**
   * notify-only or auto-deploy
   *
   * @generated from field: string tag_tracking_mode = 38;
   */
  tagTrackingMode: string;

  /**
   * Helm path: "image.digest"
   *
   * @generated from field: string image_digest_path = 39;
   */
  imageDigestPath: string;
};

/**
 * Describes the message catpocs.v1.Application.
 * Use `create(ApplicationSchema)` to create a new message.
 */
export const ApplicationSchema: GenMessage<Application> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 1);

/**
 * CreateApplicationRequest is the request message for CreateApplication
 *
 * @generated from message catpocs.v1.CreateApplicationRequest
 */
export type CreateApplicationRequest = Message<"catpocs.v1.CreateApplicationRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * User-friendly name (e.g., "My App", "TestDemo")
   *
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * Path to helm chart in repo, defaults to "helm"
   *
   * @generated from field: string path = 3;
   */
  path: string;

  /**
   * @generated from field: google.protobuf.Struct values_overrides = 4;
   */
  valuesOverrides?: JsonObject;

  /**
   * @generated from field: catpocs.v1.SyncPolicy sync_policy = 5;
   */
  syncPolicy?: SyncPolicy;

  /**
   * Optional: "app-name" in ECR
   *
   * @generated from field: string ecr_repository = 7;
   */
  ecrRepository: string;

  /**
   * Default: "image.tag"
   *
   * @generated from field: string image_tag_path = 8;
   */
  imageTagPath: string;

  /**
   * Default: "image.repository"
   *
   * @generated from field: string image_repository_path = 9;
   */
  imageRepositoryPath: string;

  /**
   * Optional: Helm path for digest pinning (e.g. "image.digest")
   *
   * @generated from field: string image_digest_path = 10;
   */
  imageDigestPath: string;
};

/**
 * Describes the message catpocs.v1.CreateApplicationRequest.
 * Use `create(CreateApplicationRequestSchema)` to create a new message.
 */
export const CreateApplicationRequestSchema: GenMessage<CreateApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 2);

/**
 * CreateApplicationResponse is the response message for CreateApplication
 *
 * @generated from message catpocs.v1.CreateApplicationResponse
 */
export type CreateApplicationResponse = Message<"catpocs.v1.CreateApplicationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;
};

/**
 * Describes the message catpocs.v1.CreateApplicationResponse.
 * Use `create(CreateApplicationResponseSchema)` to create a new message.
 */
export const CreateApplicationResponseSchema: GenMessage<CreateApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 3);

/**
 * GetApplicationRequest is the request message for GetApplication
 *
 * @generated from message catpocs.v1.GetApplicationRequest
 */
export type GetApplicationRequest = Message<"catpocs.v1.GetApplicationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationRequest.
 * Use `create(GetApplicationRequestSchema)` to create a new message.
 */
export const GetApplicationRequestSchema: GenMessage<GetApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 4);

/**
 * GetApplicationResponse is the response message for GetApplication
 *
 * @generated from message catpocs.v1.GetApplicationResponse
 */
export type GetApplicationResponse = Message<"catpocs.v1.GetApplicationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;
};

/**
 * Describes the message catpocs.v1.GetApplicationResponse.
 * Use `create(GetApplicationResponseSchema)` to create a new message.
 */
export const GetApplicationResponseSchema: GenMessage<GetApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 5);

/**
 * ListApplicationsRequest is the request message for ListApplications
 *
 * @generated from message catpocs.v1.ListApplicationsRequest
 */
export type ListApplicationsRequest = Message<"catpocs.v1.ListApplicationsRequest"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: int32 page_size = 2;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 3;
   */
  pageToken: string;
};

/**
 * Describes the message catpocs.v1.ListApplicationsRequest.
 * Use `create(ListApplicationsRequestSchema)` to create a new message.
 */
export const ListApplicationsRequestSchema: GenMessage<ListApplicationsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 6);

/**
 * ListApplicationsResponse is the response message for ListApplications
 *
 * @generated from message catpocs.v1.ListApplicationsResponse
 */
export type ListApplicationsResponse = Message<"catpocs.v1.ListApplicationsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.Application applications = 1;
   */
  applications: Application[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * @generated from field: int32 total_count = 3;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListApplicationsResponse.
 * Use `create(ListApplicationsResponseSchema)` to create a new message.
 */
export const ListApplicationsResponseSchema: GenMessage<ListApplicationsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 7);

/**
 * DeleteApplicationRequest is the request message for DeleteApplication
 *
 * @generated from message catpocs.v1.DeleteApplicationRequest
 */
export type DeleteApplicationRequest = Message<"catpocs.v1.DeleteApplicationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.DeleteApplicationRequest.
 * Use `create(DeleteApplicationRequestSchema)` to create a new message.
 */
export const DeleteApplicationRequestSchema: GenMessage<DeleteApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 8);

/**
 * DeleteApplicationResponse is the response message for DeleteApplication
 *
 * @generated from message catpocs.v1.DeleteApplicationResponse
 */
export type DeleteApplicationResponse = Message<"catpocs.v1.DeleteApplicationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.DeleteApplicationResponse.
 * Use `create(DeleteApplicationResponseSchema)` to create a new message.
 */
export const DeleteApplicationResponseSchema: GenMessage<DeleteApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 9);

/**
 * SyncApplicationRequest is the request message for SyncApplication
 *
 * @generated from message catpocs.v1.SyncApplicationRequest
 */
export type SyncApplicationRequest = Message<"catpocs.v1.SyncApplicationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: bool prune = 2;
   */
  prune: boolean;

  /**
   * @generated from field: bool dry_run = 3;
   */
  dryRun: boolean;
};

/**
 * Describes the message catpocs.v1.SyncApplicationRequest.
 * Use `create(SyncApplicationRequestSchema)` to create a new message.
 */
export const SyncApplicationRequestSchema: GenMessage<SyncApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 10);

/**
 * SyncApplicationResponse is the response message for SyncApplication
 *
 * @generated from message catpocs.v1.SyncApplicationResponse
 */
export type SyncApplicationResponse = Message<"catpocs.v1.SyncApplicationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.SyncApplicationResponse.
 * Use `create(SyncApplicationResponseSchema)` to create a new message.
 */
export const SyncApplicationResponseSchema: GenMessage<SyncApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 11);

/**
 * UpdateApplicationSyncPolicyRequest updates an application's sync policy
 *
 * @generated from message catpocs.v1.UpdateApplicationSyncPolicyRequest
 */
export type UpdateApplicationSyncPolicyRequest = Message<"catpocs.v1.UpdateApplicationSyncPolicyRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: catpocs.v1.SyncPolicy sync_policy = 2;
   */
  syncPolicy?: SyncPolicy;
};

/**
 * Describes the message catpocs.v1.UpdateApplicationSyncPolicyRequest.
 * Use `create(UpdateApplicationSyncPolicyRequestSchema)` to create a new message.
 */
export const UpdateApplicationSyncPolicyRequestSchema: GenMessage<UpdateApplicationSyncPolicyRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 12);

/**
 * UpdateApplicationSyncPolicyResponse is the response message for UpdateApplicationSyncPolicy
 *
 * @generated from message catpocs.v1.UpdateApplicationSyncPolicyResponse
 */
export type UpdateApplicationSyncPolicyResponse = Message<"catpocs.v1.UpdateApplicationSyncPolicyResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.UpdateApplicationSyncPolicyResponse.
 * Use `create(UpdateApplicationSyncPolicyResponseSchema)` to create a new message.
 */
export const UpdateApplicationSyncPolicyResponseSchema: GenMessage<UpdateApplicationSyncPolicyResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 13);

/**
 * SuspendApplicationRequest disables automated sync for an application
 *
 * @generated from message catpocs.v1.SuspendApplicationRequest
 */
export type SuspendApplicationRequest = Message<"catpocs.v1.SuspendApplicationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.SuspendApplicationRequest.
 * Use `create(SuspendApplicationRequestSchema)` to create a new message.
 */
export const SuspendApplicationRequestSchema: GenMessage<SuspendApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 14);

/**
 * SuspendApplicationResponse is the response message for SuspendApplication
 *
 * @generated from message catpocs.v1.SuspendApplicationResponse
 */
export type SuspendApplicationResponse = Message<"catpocs.v1.SuspendApplicationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.SuspendApplicationResponse.
 * Use `create(SuspendApplicationResponseSchema)` to create a new message.
 */
export const SuspendApplicationResponseSchema: GenMessage<SuspendApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 15);

/**
 * ResumeApplicationRequest re-enables automated sync for an application
 *
 * @generated from message catpocs.v1.ResumeApplicationRequest
 */
export type ResumeApplicationRequest = Message<"catpocs.v1.ResumeApplicationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.ResumeApplicationRequest.
 * Use `create(ResumeApplicationRequestSchema)` to create a new message.
 */
export const ResumeApplicationRequestSchema: GenMessage<ResumeApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 16);

/**
 * ResumeApplicationResponse is the response message for ResumeApplication
 *
 * @generated from message catpocs.v1.ResumeApplicationResponse
 */
export type ResumeApplicationResponse = Message<"catpocs.v1.ResumeApplicationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: string message = 2;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.ResumeApplicationResponse.
 * Use `create(ResumeApplicationResponseSchema)` to create a new message.
 */
export const ResumeApplicationResponseSchema: GenMessage<ResumeApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 17);

/**
 * GetApplicationLogsRequest is the request message for GetApplicationLogs
 *
 * @generated from message catpocs.v1.GetApplicationLogsRequest
 */
export type GetApplicationLogsRequest = Message<"catpocs.v1.GetApplicationLogsRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string pod_name = 2;
   */
  podName: string;

  /**
   * @generated from field: string container_name = 3;
   */
  containerName: string;

  /**
   * @generated from field: int64 tail_lines = 4;
   */
  tailLines: bigint;

  /**
   * @generated from field: bool follow = 5;
   */
  follow: boolean;
};

/**
 * Describes the message catpocs.v1.GetApplicationLogsRequest.
 * Use `create(GetApplicationLogsRequestSchema)` to create a new message.
 */
export const GetApplicationLogsRequestSchema: GenMessage<GetApplicationLogsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 18);

/**
 * GetApplicationLogsResponse is the response message for GetApplicationLogs
 *
 * @generated from message catpocs.v1.GetApplicationLogsResponse
 */
export type GetApplicationLogsResponse = Message<"catpocs.v1.GetApplicationLogsResponse"> & {
  /**
   * @generated from field: string log_line = 1;
   */
  logLine: string;

  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 2;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: string pod_name = 3;
   */
  podName: string;

  /**
   * @generated from field: string container_name = 4;
   */
  containerName: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationLogsResponse.
 * Use `create(GetApplicationLogsResponseSchema)` to create a new message.
 */
export const GetApplicationLogsResponseSchema: GenMessage<GetApplicationLogsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 19);

/**
 * GetApplicationEventsRequest is the request message for GetApplicationEvents
 *
 * @generated from message catpocs.v1.GetApplicationEventsRequest
 */
export type GetApplicationEventsRequest = Message<"catpocs.v1.GetApplicationEventsRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationEventsRequest.
 * Use `create(GetApplicationEventsRequestSchema)` to create a new message.
 */
export const GetApplicationEventsRequestSchema: GenMessage<GetApplicationEventsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 20);

/**
 * Event represents a Kubernetes event
 *
 * @generated from message catpocs.v1.Event
 */
export type Event = Message<"catpocs.v1.Event"> & {
  /**
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: string source = 4;
   */
  source: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_timestamp = 5;
   */
  firstTimestamp?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_timestamp = 6;
   */
  lastTimestamp?: Timestamp;

  /**
   * @generated from field: int32 count = 7;
   */
  count: number;
};

/**
 * Describes the message catpocs.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 21);

/**
 * GetApplicationEventsResponse is the response message for GetApplicationEvents
 *
 * @generated from message catpocs.v1.GetApplicationEventsResponse
 */
export type GetApplicationEventsResponse = Message<"catpocs.v1.GetApplicationEventsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.Event events = 1;
   */
  events: Event[];
};

/**
 * Describes the message catpocs.v1.GetApplicationEventsResponse.
 * Use `create(GetApplicationEventsResponseSchema)` to create a new message.
 */
export const GetApplicationEventsResponseSchema: GenMessage<GetApplicationEventsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 22);

/**
 * GetApplicationDiffRequest is the request message for GetApplicationDiff
 *
 * @generated from message catpocs.v1.GetApplicationDiffRequest
 */
export type GetApplicationDiffRequest = Message<"catpocs.v1.GetApplicationDiffRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationDiffRequest.
 * Use `create(GetApplicationDiffRequestSchema)` to create a new message.
 */
export const GetApplicationDiffRequestSchema: GenMessage<GetApplicationDiffRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 23);

/**
 * ResourceDiff represents the diff for a single resource
 *
 * @generated from message catpocs.v1.ResourceDiff
 */
export type ResourceDiff = Message<"catpocs.v1.ResourceDiff"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string namespace = 3;
   */
  namespace: string;

  /**
   * @generated from field: string live_state = 4;
   */
  liveState: string;

  /**
   * @generated from field: string target_state = 5;
   */
  targetState: string;

  /**
   * @generated from field: string diff = 6;
   */
  diff: string;

  /**
   * @generated from field: bool in_sync = 7;
   */
  inSync: boolean;
};

/**
 * Describes the message catpocs.v1.ResourceDiff.
 * Use `create(ResourceDiffSchema)` to create a new message.
 */
export const ResourceDiffSchema: GenMessage<ResourceDiff> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 24);

/**
 * GetApplicationDiffResponse is the response message for GetApplicationDiff
 *
 * @generated from message catpocs.v1.GetApplicationDiffResponse
 */
export type GetApplicationDiffResponse = Message<"catpocs.v1.GetApplicationDiffResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.ResourceDiff diffs = 1;
   */
  diffs: ResourceDiff[];
};

/**
 * Describes the message catpocs.v1.GetApplicationDiffResponse.
 * Use `create(GetApplicationDiffResponseSchema)` to create a new message.
 */
export const GetApplicationDiffResponseSchema: GenMessage<GetApplicationDiffResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 25);

/**
 * GetDeploymentHistoryRequest is the request message for GetDeploymentHistory
 *
 * @generated from message catpocs.v1.GetDeploymentHistoryRequest
 */
export type GetDeploymentHistoryRequest = Message<"catpocs.v1.GetDeploymentHistoryRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message catpocs.v1.GetDeploymentHistoryRequest.
 * Use `create(GetDeploymentHistoryRequestSchema)` to create a new message.
 */
export const GetDeploymentHistoryRequestSchema: GenMessage<GetDeploymentHistoryRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 26);

/**
 * DeploymentHistoryEntry represents a deployment history entry
 *
 * @generated from message catpocs.v1.DeploymentHistoryEntry
 */
export type DeploymentHistoryEntry = Message<"catpocs.v1.DeploymentHistoryEntry"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string revision = 2;
   */
  revision: string;

  /**
   * @generated from field: google.protobuf.Timestamp deployed_at = 3;
   */
  deployedAt?: Timestamp;

  /**
   * @generated from field: string deployed_by = 4;
   */
  deployedBy: string;

  /**
   * @generated from field: string source_repo = 5;
   */
  sourceRepo: string;

  /**
   * @generated from field: string source_path = 6;
   */
  sourcePath: string;
};

/**
 * Describes the message catpocs.v1.DeploymentHistoryEntry.
 * Use `create(DeploymentHistoryEntrySchema)` to create a new message.
 */
export const DeploymentHistoryEntrySchema: GenMessage<DeploymentHistoryEntry> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 27);

/**
 * GetDeploymentHistoryResponse is the response message for GetDeploymentHistory
 *
 * @generated from message catpocs.v1.GetDeploymentHistoryResponse
 */
export type GetDeploymentHistoryResponse = Message<"catpocs.v1.GetDeploymentHistoryResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.DeploymentHistoryEntry history = 1;
   */
  history: DeploymentHistoryEntry[];
};

/**
 * Describes the message catpocs.v1.GetDeploymentHistoryResponse.
 * Use `create(GetDeploymentHistoryResponseSchema)` to create a new message.
 */
export const GetDeploymentHistoryResponseSchema: GenMessage<GetDeploymentHistoryResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 28);

/**
 * RetryCreateCRDRequest is the request message for RetryCreateCRD
 *
 * @generated from message catpocs.v1.RetryCreateCRDRequest
 */
export type RetryCreateCRDRequest = Message<"catpocs.v1.RetryCreateCRDRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.RetryCreateCRDRequest.
 * Use `create(RetryCreateCRDRequestSchema)` to create a new message.
 */
export const RetryCreateCRDRequestSchema: GenMessage<RetryCreateCRDRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 29);

/**
 * RetryCreateCRDResponse is the response message for RetryCreateCRD
 *
 * @generated from message catpocs.v1.RetryCreateCRDResponse
 */
export type RetryCreateCRDResponse = Message<"catpocs.v1.RetryCreateCRDResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.RetryCreateCRDResponse.
 * Use `create(RetryCreateCRDResponseSchema)` to create a new message.
 */
export const RetryCreateCRDResponseSchema: GenMessage<RetryCreateCRDResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 30);

/**
 * RetryHelmValidationRequest is the request message for RetryHelmValidation
 *
 * @generated from message catpocs.v1.RetryHelmValidationRequest
 */
export type RetryHelmValidationRequest = Message<"catpocs.v1.RetryHelmValidationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.RetryHelmValidationRequest.
 * Use `create(RetryHelmValidationRequestSchema)` to create a new message.
 */
export const RetryHelmValidationRequestSchema: GenMessage<RetryHelmValidationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 31);

/**
 * RetryHelmValidationResponse is the response message for RetryHelmValidation
 *
 * @generated from message catpocs.v1.RetryHelmValidationResponse
 */
export type RetryHelmValidationResponse = Message<"catpocs.v1.RetryHelmValidationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.RetryHelmValidationResponse.
 * Use `create(RetryHelmValidationResponseSchema)` to create a new message.
 */
export const RetryHelmValidationResponseSchema: GenMessage<RetryHelmValidationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 32);

/**
 * RetryApplicationSetupRequest is the request message for RetryApplicationSetup
 *
 * @generated from message catpocs.v1.RetryApplicationSetupRequest
 */
export type RetryApplicationSetupRequest = Message<"catpocs.v1.RetryApplicationSetupRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.RetryApplicationSetupRequest.
 * Use `create(RetryApplicationSetupRequestSchema)` to create a new message.
 */
export const RetryApplicationSetupRequestSchema: GenMessage<RetryApplicationSetupRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 33);

/**
 * RetryApplicationSetupResponse is the response message for RetryApplicationSetup
 *
 * @generated from message catpocs.v1.RetryApplicationSetupResponse
 */
export type RetryApplicationSetupResponse = Message<"catpocs.v1.RetryApplicationSetupResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.RetryApplicationSetupResponse.
 * Use `create(RetryApplicationSetupResponseSchema)` to create a new message.
 */
export const RetryApplicationSetupResponseSchema: GenMessage<RetryApplicationSetupResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 34);

/**
 * StartApplicationValidationRequest triggers validation from Created state
 *
 * @generated from message catpocs.v1.StartApplicationValidationRequest
 */
export type StartApplicationValidationRequest = Message<"catpocs.v1.StartApplicationValidationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.StartApplicationValidationRequest.
 * Use `create(StartApplicationValidationRequestSchema)` to create a new message.
 */
export const StartApplicationValidationRequestSchema: GenMessage<StartApplicationValidationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 35);

/**
 * StartApplicationValidationResponse is the response message for StartApplicationValidation
 *
 * @generated from message catpocs.v1.StartApplicationValidationResponse
 */
export type StartApplicationValidationResponse = Message<"catpocs.v1.StartApplicationValidationResponse"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * @generated from field: bool success = 2;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.StartApplicationValidationResponse.
 * Use `create(StartApplicationValidationResponseSchema)` to create a new message.
 */
export const StartApplicationValidationResponseSchema: GenMessage<StartApplicationValidationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 36);

/**
 * ForceDeleteApplicationRequest is the request message for ForceDeleteApplication
 *
 * @generated from message catpocs.v1.ForceDeleteApplicationRequest
 */
export type ForceDeleteApplicationRequest = Message<"catpocs.v1.ForceDeleteApplicationRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.ForceDeleteApplicationRequest.
 * Use `create(ForceDeleteApplicationRequestSchema)` to create a new message.
 */
export const ForceDeleteApplicationRequestSchema: GenMessage<ForceDeleteApplicationRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 37);

/**
 * ForceDeleteApplicationResponse is the response message for ForceDeleteApplication
 *
 * @generated from message catpocs.v1.ForceDeleteApplicationResponse
 */
export type ForceDeleteApplicationResponse = Message<"catpocs.v1.ForceDeleteApplicationResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message catpocs.v1.ForceDeleteApplicationResponse.
 * Use `create(ForceDeleteApplicationResponseSchema)` to create a new message.
 */
export const ForceDeleteApplicationResponseSchema: GenMessage<ForceDeleteApplicationResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 38);

/**
 * UpsertApplicationGitHubVariablesRequest creates/updates repo-level Actions variables for this application.
 *
 * @generated from message catpocs.v1.UpsertApplicationGitHubVariablesRequest
 */
export type UpsertApplicationGitHubVariablesRequest = Message<"catpocs.v1.UpsertApplicationGitHubVariablesRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message catpocs.v1.UpsertApplicationGitHubVariablesRequest.
 * Use `create(UpsertApplicationGitHubVariablesRequestSchema)` to create a new message.
 */
export const UpsertApplicationGitHubVariablesRequestSchema: GenMessage<UpsertApplicationGitHubVariablesRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 39);

/**
 * UpsertApplicationGitHubVariablesResponse summarizes repository variable operations.
 *
 * @generated from message catpocs.v1.UpsertApplicationGitHubVariablesResponse
 */
export type UpsertApplicationGitHubVariablesResponse = Message<"catpocs.v1.UpsertApplicationGitHubVariablesResponse"> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;

  /**
   * owner/repo
   *
   * @generated from field: string repository = 2;
   */
  repository: string;

  /**
   * @generated from field: repeated string created = 3;
   */
  created: string[];

  /**
   * @generated from field: repeated string updated = 4;
   */
  updated: string[];

  /**
   * @generated from field: repeated string unchanged = 5;
   */
  unchanged: string[];
};

/**
 * Describes the message catpocs.v1.UpsertApplicationGitHubVariablesResponse.
 * Use `create(UpsertApplicationGitHubVariablesResponseSchema)` to create a new message.
 */
export const UpsertApplicationGitHubVariablesResponseSchema: GenMessage<UpsertApplicationGitHubVariablesResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 40);

/**
 * GetApplicationTrafficMetricsRequest is the request for traffic metrics
 *
 * @generated from message catpocs.v1.GetApplicationTrafficMetricsRequest
 */
export type GetApplicationTrafficMetricsRequest = Message<"catpocs.v1.GetApplicationTrafficMetricsRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * e.g., "24h", "7d", "30d"
   *
   * @generated from field: string duration = 2;
   */
  duration: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationTrafficMetricsRequest.
 * Use `create(GetApplicationTrafficMetricsRequestSchema)` to create a new message.
 */
export const GetApplicationTrafficMetricsRequestSchema: GenMessage<GetApplicationTrafficMetricsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 41);

/**
 * TrafficDataPoint represents a single data point in the traffic graph
 *
 * @generated from message catpocs.v1.TrafficDataPoint
 */
export type TrafficDataPoint = Message<"catpocs.v1.TrafficDataPoint"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: double value = 2;
   */
  value: number;
};

/**
 * Describes the message catpocs.v1.TrafficDataPoint.
 * Use `create(TrafficDataPointSchema)` to create a new message.
 */
export const TrafficDataPointSchema: GenMessage<TrafficDataPoint> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 42);

/**
 * GetApplicationTrafficMetricsResponse contains traffic metrics from Traefik/Prometheus
 *
 * @generated from message catpocs.v1.GetApplicationTrafficMetricsResponse
 */
export type GetApplicationTrafficMetricsResponse = Message<"catpocs.v1.GetApplicationTrafficMetricsResponse"> & {
  /**
   * @generated from field: int64 total_requests = 1;
   */
  totalRequests: bigint;

  /**
   * @generated from field: repeated catpocs.v1.TrafficDataPoint requests_over_time = 2;
   */
  requestsOverTime: TrafficDataPoint[];

  /**
   * e.g., {"200": 1500, "404": 10, "500": 5}
   *
   * @generated from field: map<string, int64> status_code_counts = 3;
   */
  statusCodeCounts: { [key: string]: bigint };

  /**
   * @generated from field: double avg_response_time_ms = 4;
   */
  avgResponseTimeMs: number;

  /**
   * @generated from field: double error_rate_percent = 5;
   */
  errorRatePercent: number;

  /**
   * e.g., {"GET": 1200, "POST": 300}
   *
   * @generated from field: map<string, int64> requests_by_method = 6;
   */
  requestsByMethod: { [key: string]: bigint };

  /**
   * false if Prometheus unavailable or no data
   *
   * @generated from field: bool metrics_available = 7;
   */
  metricsAvailable: boolean;

  /**
   * Human-readable status message
   *
   * @generated from field: string message = 8;
   */
  message: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationTrafficMetricsResponse.
 * Use `create(GetApplicationTrafficMetricsResponseSchema)` to create a new message.
 */
export const GetApplicationTrafficMetricsResponseSchema: GenMessage<GetApplicationTrafficMetricsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 43);

/**
 * GetApplicationResourceStatusRequest is the request for detailed resource status
 *
 * @generated from message catpocs.v1.GetApplicationResourceStatusRequest
 */
export type GetApplicationResourceStatusRequest = Message<"catpocs.v1.GetApplicationResourceStatusRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationResourceStatusRequest.
 * Use `create(GetApplicationResourceStatusRequestSchema)` to create a new message.
 */
export const GetApplicationResourceStatusRequestSchema: GenMessage<GetApplicationResourceStatusRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 44);

/**
 * PodStatus represents the status of a single pod
 *
 * @generated from message catpocs.v1.PodStatus
 */
export type PodStatus = Message<"catpocs.v1.PodStatus"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string namespace = 2;
   */
  namespace: string;

  /**
   * Running, Pending, Failed, Succeeded, Unknown
   *
   * @generated from field: string phase = 3;
   */
  phase: string;

  /**
   * Reason for non-Running state
   *
   * @generated from field: string reason = 4;
   */
  reason: string;

  /**
   * Detailed message
   *
   * @generated from field: string message = 5;
   */
  message: string;

  /**
   * @generated from field: int32 restart_count = 6;
   */
  restartCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 7;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: bool ready = 8;
   */
  ready: boolean;

  /**
   * @generated from field: repeated catpocs.v1.ContainerStatus containers = 9;
   */
  containers: ContainerStatus[];
};

/**
 * Describes the message catpocs.v1.PodStatus.
 * Use `create(PodStatusSchema)` to create a new message.
 */
export const PodStatusSchema: GenMessage<PodStatus> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 45);

/**
 * ContainerStatus represents the status of a container
 *
 * @generated from message catpocs.v1.ContainerStatus
 */
export type ContainerStatus = Message<"catpocs.v1.ContainerStatus"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: bool ready = 2;
   */
  ready: boolean;

  /**
   * @generated from field: int32 restart_count = 3;
   */
  restartCount: number;

  /**
   * Running, Waiting, Terminated
   *
   * @generated from field: string state = 4;
   */
  state: string;

  /**
   * @generated from field: string state_reason = 5;
   */
  stateReason: string;

  /**
   * @generated from field: string state_message = 6;
   */
  stateMessage: string;

  /**
   * @generated from field: string image = 7;
   */
  image: string;
};

/**
 * Describes the message catpocs.v1.ContainerStatus.
 * Use `create(ContainerStatusSchema)` to create a new message.
 */
export const ContainerStatusSchema: GenMessage<ContainerStatus> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 46);

/**
 * ResourceEvent represents a Kubernetes event
 *
 * @generated from message catpocs.v1.ResourceEvent
 */
export type ResourceEvent = Message<"catpocs.v1.ResourceEvent"> & {
  /**
   * Normal, Warning
   *
   * @generated from field: string type = 1;
   */
  type: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;

  /**
   * @generated from field: string message = 3;
   */
  message: string;

  /**
   * @generated from field: google.protobuf.Timestamp first_timestamp = 4;
   */
  firstTimestamp?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp last_timestamp = 5;
   */
  lastTimestamp?: Timestamp;

  /**
   * @generated from field: int32 count = 6;
   */
  count: number;

  /**
   * Component that generated the event
   *
   * @generated from field: string source = 7;
   */
  source: string;

  /**
   * e.g., "Pod/my-app-abc123"
   *
   * @generated from field: string involved_object = 8;
   */
  involvedObject: string;
};

/**
 * Describes the message catpocs.v1.ResourceEvent.
 * Use `create(ResourceEventSchema)` to create a new message.
 */
export const ResourceEventSchema: GenMessage<ResourceEvent> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 47);

/**
 * GetApplicationResourceStatusResponse contains detailed resource status
 *
 * @generated from message catpocs.v1.GetApplicationResourceStatusResponse
 */
export type GetApplicationResourceStatusResponse = Message<"catpocs.v1.GetApplicationResourceStatusResponse"> & {
  /**
   * @generated from field: string sync_status = 1;
   */
  syncStatus: string;

  /**
   * @generated from field: string health_status = 2;
   */
  healthStatus: string;

  /**
   * @generated from field: string health_message = 3;
   */
  healthMessage: string;

  /**
   * @generated from field: repeated catpocs.v1.PodStatus pods = 4;
   */
  pods: PodStatus[];

  /**
   * @generated from field: repeated catpocs.v1.ResourceEvent events = 5;
   */
  events: ResourceEvent[];

  /**
   * @generated from field: int32 desired_replicas = 6;
   */
  desiredReplicas: number;

  /**
   * @generated from field: int32 ready_replicas = 7;
   */
  readyReplicas: number;

  /**
   * @generated from field: int32 available_replicas = 8;
   */
  availableReplicas: number;

  /**
   * @generated from field: google.protobuf.Timestamp last_sync_time = 9;
   */
  lastSyncTime?: Timestamp;

  /**
   * Error message if sync failed
   *
   * @generated from field: string sync_error = 10;
   */
  syncError: string;
};

/**
 * Describes the message catpocs.v1.GetApplicationResourceStatusResponse.
 * Use `create(GetApplicationResourceStatusResponseSchema)` to create a new message.
 */
export const GetApplicationResourceStatusResponseSchema: GenMessage<GetApplicationResourceStatusResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 48);

/**
 * ListApplicationsWithIssuesRequest is the request for listing applications with issues
 *
 * Empty - returns all applications with issues the user has access to
 *
 * @generated from message catpocs.v1.ListApplicationsWithIssuesRequest
 */
export type ListApplicationsWithIssuesRequest = Message<"catpocs.v1.ListApplicationsWithIssuesRequest"> & {
};

/**
 * Describes the message catpocs.v1.ListApplicationsWithIssuesRequest.
 * Use `create(ListApplicationsWithIssuesRequestSchema)` to create a new message.
 */
export const ListApplicationsWithIssuesRequestSchema: GenMessage<ListApplicationsWithIssuesRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 49);

/**
 * ApplicationWithIssue represents an application with issue details
 *
 * @generated from message catpocs.v1.ApplicationWithIssue
 */
export type ApplicationWithIssue = Message<"catpocs.v1.ApplicationWithIssue"> & {
  /**
   * @generated from field: catpocs.v1.Application application = 1;
   */
  application?: Application;

  /**
   * Project name for display
   *
   * @generated from field: string project_name = 2;
   */
  projectName: string;

  /**
   * "out_of_sync", "degraded", "crd_error", "unhealthy"
   *
   * @generated from field: string issue_type = 3;
   */
  issueType: string;

  /**
   * Human-readable description of the issue
   *
   * @generated from field: string issue_description = 4;
   */
  issueDescription: string;
};

/**
 * Describes the message catpocs.v1.ApplicationWithIssue.
 * Use `create(ApplicationWithIssueSchema)` to create a new message.
 */
export const ApplicationWithIssueSchema: GenMessage<ApplicationWithIssue> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 50);

/**
 * ListApplicationsWithIssuesResponse contains applications with issues
 *
 * @generated from message catpocs.v1.ListApplicationsWithIssuesResponse
 */
export type ListApplicationsWithIssuesResponse = Message<"catpocs.v1.ListApplicationsWithIssuesResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.ApplicationWithIssue applications = 1;
   */
  applications: ApplicationWithIssue[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListApplicationsWithIssuesResponse.
 * Use `create(ListApplicationsWithIssuesResponseSchema)` to create a new message.
 */
export const ListApplicationsWithIssuesResponseSchema: GenMessage<ListApplicationsWithIssuesResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 51);

/**
 * @generated from message catpocs.v1.StreamApplicationStatusRequest
 */
export type StreamApplicationStatusRequest = Message<"catpocs.v1.StreamApplicationStatusRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;
};

/**
 * Describes the message catpocs.v1.StreamApplicationStatusRequest.
 * Use `create(StreamApplicationStatusRequestSchema)` to create a new message.
 */
export const StreamApplicationStatusRequestSchema: GenMessage<StreamApplicationStatusRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 52);

/**
 * @generated from message catpocs.v1.StreamApplicationStatusResponse
 */
export type StreamApplicationStatusResponse = Message<"catpocs.v1.StreamApplicationStatusResponse"> & {
  /**
   * @generated from field: string state = 1;
   */
  state: string;

  /**
   * @generated from field: string state_message = 2;
   */
  stateMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp state_updated_at = 3;
   */
  stateUpdatedAt?: Timestamp;

  /**
   * 0-100 for UI progress bars
   *
   * @generated from field: int32 progress_percent = 4;
   */
  progressPercent: number;
};

/**
 * Describes the message catpocs.v1.StreamApplicationStatusResponse.
 * Use `create(StreamApplicationStatusResponseSchema)` to create a new message.
 */
export const StreamApplicationStatusResponseSchema: GenMessage<StreamApplicationStatusResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 53);

/**
 * ListApplicationSetupAttemptsRequest lists setup attempts for one application.
 *
 * @generated from message catpocs.v1.ListApplicationSetupAttemptsRequest
 */
export type ListApplicationSetupAttemptsRequest = Message<"catpocs.v1.ListApplicationSetupAttemptsRequest"> & {
  /**
   * @generated from field: string application_id = 1;
   */
  applicationId: string;

  /**
   * default 20, max 100
   *
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message catpocs.v1.ListApplicationSetupAttemptsRequest.
 * Use `create(ListApplicationSetupAttemptsRequestSchema)` to create a new message.
 */
export const ListApplicationSetupAttemptsRequestSchema: GenMessage<ListApplicationSetupAttemptsRequest> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 54);

/**
 * ApplicationSetupAttempt is a persisted setup workflow attempt.
 *
 * @generated from message catpocs.v1.ApplicationSetupAttempt
 */
export type ApplicationSetupAttempt = Message<"catpocs.v1.ApplicationSetupAttempt"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string application_id = 2;
   */
  applicationId: string;

  /**
   * @generated from field: string workflow = 3;
   */
  workflow: string;

  /**
   * @generated from field: string status = 4;
   */
  status: string;

  /**
   * @generated from field: int32 attempts = 5;
   */
  attempts: number;

  /**
   * @generated from field: int32 max_attempts = 6;
   */
  maxAttempts: number;

  /**
   * @generated from field: string correlation_id = 7;
   */
  correlationId: string;

  /**
   * @generated from field: string idempotency_key = 8;
   */
  idempotencyKey: string;

  /**
   * @generated from field: string triggered_by = 9;
   */
  triggeredBy: string;

  /**
   * @generated from field: string trigger_reason = 10;
   */
  triggerReason: string;

  /**
   * @generated from field: string final_state = 11;
   */
  finalState: string;

  /**
   * @generated from field: string error_message = 12;
   */
  errorMessage: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 14;
   */
  startedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp completed_at = 15;
   */
  completedAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp next_attempt_at = 16;
   */
  nextAttemptAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 17;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message catpocs.v1.ApplicationSetupAttempt.
 * Use `create(ApplicationSetupAttemptSchema)` to create a new message.
 */
export const ApplicationSetupAttemptSchema: GenMessage<ApplicationSetupAttempt> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 55);

/**
 * ListApplicationSetupAttemptsResponse contains recent setup attempts.
 *
 * @generated from message catpocs.v1.ListApplicationSetupAttemptsResponse
 */
export type ListApplicationSetupAttemptsResponse = Message<"catpocs.v1.ListApplicationSetupAttemptsResponse"> & {
  /**
   * @generated from field: repeated catpocs.v1.ApplicationSetupAttempt attempts = 1;
   */
  attempts: ApplicationSetupAttempt[];

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message catpocs.v1.ListApplicationSetupAttemptsResponse.
 * Use `create(ListApplicationSetupAttemptsResponseSchema)` to create a new message.
 */
export const ListApplicationSetupAttemptsResponseSchema: GenMessage<ListApplicationSetupAttemptsResponse> = /*@__PURE__*/
  messageDesc(file_catpocs_v1_applications, 56);

/**
 * ApplicationService manages ArgoCD applications
 *
 * @generated from service catpocs.v1.ApplicationService
 */
export const ApplicationService: GenService<{
  /**
   * CreateApplication creates a new ArgoCD application
   *
   * @generated from rpc catpocs.v1.ApplicationService.CreateApplication
   */
  createApplication: {
    methodKind: "unary";
    input: typeof CreateApplicationRequestSchema;
    output: typeof CreateApplicationResponseSchema;
  },
  /**
   * GetApplication retrieves an application by ID
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetApplication
   */
  getApplication: {
    methodKind: "unary";
    input: typeof GetApplicationRequestSchema;
    output: typeof GetApplicationResponseSchema;
  },
  /**
   * ListApplications lists all applications in a project
   *
   * @generated from rpc catpocs.v1.ApplicationService.ListApplications
   */
  listApplications: {
    methodKind: "unary";
    input: typeof ListApplicationsRequestSchema;
    output: typeof ListApplicationsResponseSchema;
  },
  /**
   * DeleteApplication soft-deletes an application and triggers ArgoCD CRD deletion
   *
   * @generated from rpc catpocs.v1.ApplicationService.DeleteApplication
   */
  deleteApplication: {
    methodKind: "unary";
    input: typeof DeleteApplicationRequestSchema;
    output: typeof DeleteApplicationResponseSchema;
  },
  /**
   * SyncApplication triggers a sync for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.SyncApplication
   */
  syncApplication: {
    methodKind: "unary";
    input: typeof SyncApplicationRequestSchema;
    output: typeof SyncApplicationResponseSchema;
  },
  /**
   * UpdateApplicationSyncPolicy updates the sync policy for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.UpdateApplicationSyncPolicy
   */
  updateApplicationSyncPolicy: {
    methodKind: "unary";
    input: typeof UpdateApplicationSyncPolicyRequestSchema;
    output: typeof UpdateApplicationSyncPolicyResponseSchema;
  },
  /**
   * SuspendApplication disables automated sync for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.SuspendApplication
   */
  suspendApplication: {
    methodKind: "unary";
    input: typeof SuspendApplicationRequestSchema;
    output: typeof SuspendApplicationResponseSchema;
  },
  /**
   * ResumeApplication re-enables automated sync for a suspended application
   *
   * @generated from rpc catpocs.v1.ApplicationService.ResumeApplication
   */
  resumeApplication: {
    methodKind: "unary";
    input: typeof ResumeApplicationRequestSchema;
    output: typeof ResumeApplicationResponseSchema;
  },
  /**
   * RetryCreateCRD retries creating the ArgoCD CRD for an application with crd_error
   *
   * @generated from rpc catpocs.v1.ApplicationService.RetryCreateCRD
   */
  retryCreateCRD: {
    methodKind: "unary";
    input: typeof RetryCreateCRDRequestSchema;
    output: typeof RetryCreateCRDResponseSchema;
  },
  /**
   * RetryHelmValidation retries Helm validation for a failed application
   *
   * @generated from rpc catpocs.v1.ApplicationService.RetryHelmValidation
   */
  retryHelmValidation: {
    methodKind: "unary";
    input: typeof RetryHelmValidationRequestSchema;
    output: typeof RetryHelmValidationResponseSchema;
  },
  /**
   * RetryApplicationSetup retries setup for RepoValidationFailed or AWSProvisioningFailed (e.g. after installing GitHub App on repo)
   *
   * @generated from rpc catpocs.v1.ApplicationService.RetryApplicationSetup
   */
  retryApplicationSetup: {
    methodKind: "unary";
    input: typeof RetryApplicationSetupRequestSchema;
    output: typeof RetryApplicationSetupResponseSchema;
  },
  /**
   * StartApplicationValidation triggers Helm validation from Created state
   *
   * @generated from rpc catpocs.v1.ApplicationService.StartApplicationValidation
   */
  startApplicationValidation: {
    methodKind: "unary";
    input: typeof StartApplicationValidationRequestSchema;
    output: typeof StartApplicationValidationResponseSchema;
  },
  /**
   * ForceDeleteApplication hard-deletes an application (project admin only - for stuck deletions)
   *
   * @generated from rpc catpocs.v1.ApplicationService.ForceDeleteApplication
   */
  forceDeleteApplication: {
    methodKind: "unary";
    input: typeof ForceDeleteApplicationRequestSchema;
    output: typeof ForceDeleteApplicationResponseSchema;
  },
  /**
   * UpsertApplicationGitHubVariables creates/updates GitHub Actions repository variables for this application.
   *
   * @generated from rpc catpocs.v1.ApplicationService.UpsertApplicationGitHubVariables
   */
  upsertApplicationGitHubVariables: {
    methodKind: "unary";
    input: typeof UpsertApplicationGitHubVariablesRequestSchema;
    output: typeof UpsertApplicationGitHubVariablesResponseSchema;
  },
  /**
   * GetApplicationLogs retrieves logs for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetApplicationLogs
   */
  getApplicationLogs: {
    methodKind: "server_streaming";
    input: typeof GetApplicationLogsRequestSchema;
    output: typeof GetApplicationLogsResponseSchema;
  },
  /**
   * GetApplicationEvents retrieves Kubernetes events for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetApplicationEvents
   */
  getApplicationEvents: {
    methodKind: "unary";
    input: typeof GetApplicationEventsRequestSchema;
    output: typeof GetApplicationEventsResponseSchema;
  },
  /**
   * GetApplicationDiff retrieves the diff between desired and live state
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetApplicationDiff
   */
  getApplicationDiff: {
    methodKind: "unary";
    input: typeof GetApplicationDiffRequestSchema;
    output: typeof GetApplicationDiffResponseSchema;
  },
  /**
   * GetDeploymentHistory retrieves deployment history for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetDeploymentHistory
   */
  getDeploymentHistory: {
    methodKind: "unary";
    input: typeof GetDeploymentHistoryRequestSchema;
    output: typeof GetDeploymentHistoryResponseSchema;
  },
  /**
   * GetApplicationTrafficMetrics retrieves Traefik traffic metrics for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetApplicationTrafficMetrics
   */
  getApplicationTrafficMetrics: {
    methodKind: "unary";
    input: typeof GetApplicationTrafficMetricsRequestSchema;
    output: typeof GetApplicationTrafficMetricsResponseSchema;
  },
  /**
   * GetApplicationResourceStatus retrieves detailed resource status (pods, events) for an application
   *
   * @generated from rpc catpocs.v1.ApplicationService.GetApplicationResourceStatus
   */
  getApplicationResourceStatus: {
    methodKind: "unary";
    input: typeof GetApplicationResourceStatusRequestSchema;
    output: typeof GetApplicationResourceStatusResponseSchema;
  },
  /**
   * ListApplicationsWithIssues lists all applications that have issues (out of sync, degraded, CRD errors)
   *
   * @generated from rpc catpocs.v1.ApplicationService.ListApplicationsWithIssues
   */
  listApplicationsWithIssues: {
    methodKind: "unary";
    input: typeof ListApplicationsWithIssuesRequestSchema;
    output: typeof ListApplicationsWithIssuesResponseSchema;
  },
  /**
   * StreamApplicationStatus provides real-time application state updates
   *
   * @generated from rpc catpocs.v1.ApplicationService.StreamApplicationStatus
   */
  streamApplicationStatus: {
    methodKind: "server_streaming";
    input: typeof StreamApplicationStatusRequestSchema;
    output: typeof StreamApplicationStatusResponseSchema;
  },
  /**
   * ListApplicationSetupAttempts returns durable setup attempt history for an application.
   *
   * @generated from rpc catpocs.v1.ApplicationService.ListApplicationSetupAttempts
   */
  listApplicationSetupAttempts: {
    methodKind: "unary";
    input: typeof ListApplicationSetupAttemptsRequestSchema;
    output: typeof ListApplicationSetupAttemptsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_catpocs_v1_applications, 0);

